import React from 'react';
import Navigation from './components/Navigation';
import Header from './components/Header';
import About from './components/About';
import Skills from './components/Skills';
import Projects from './components/Projects';
import Experience from './components/Experience';
import Contact from './components/Contact';
import Footer from './components/Footer';
import './styles/theme.css';
import './styles/global.css';
import './styles/global-theme.css';
import {ThemeProvider} from './context/theme-context';
import ThemeSwitcher from './components/ThemeSwitcher';
import Testimonials from "./components/Testimonials";

function App() {
    return (
        <ThemeProvider>
            <div className="App">
                <Navigation/>
                <ThemeSwitcher/>
                <About/>
                <Skills/>
                <Experience/>
                <Projects/>
                <Testimonials/>
                <Contact/>
                <Footer/>
            </div>
        </ThemeProvider>
    );
}

export default App;